import { createAction, props } from '@ngrx/store'

export const SOURCE = '[Map Color Generator]'

export const getNextColors = createAction(
    `${SOURCE} GetNextColors`, props<{ num: number; ident: string }>()
)

export const setColorMap = createAction(
    `${SOURCE} SetColorMap`, props<{ colorMap: any; colorOffset: number }>()
)

export const resetColors = createAction(
    `${SOURCE} ResetColors`
)

export const noAction = createAction(`${SOURCE} NoAction`)